export default __webpack_public_path__ + "static/media/balam-pichkari.b3a65159.jpg";